module.exports = __webpack_public_path__ + "img/solution-image.60166f5c.svg";